import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Row,
  Col,
  Form,
  Select,
  Breadcrumb,
  Input,
  Spin,
  Space,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import "../../../styles/Main.scss";
import { MinusSquareFilled, PlusSquareFilled } from "@ant-design/icons";
import { ReactComponent as RupeesSign } from "../../../image/RupeesSign.svg";
import { ReactComponent as CoinIcon } from "../../../image/CoinIcon.svg";
import { ReactComponent as ClockIcon } from "../../../image/ClockIcon.svg";
import { ReactComponent as About } from "../../../image/About.svg";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import InputField from "../../../common/htmlComponents/InputField";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import { authUserData } from "../../../utils/Helper";

const AddSubscription = () => {
  const { t } = useTranslation();
  const formRef = useRef();
  const navigate = useNavigate();

  const { id } = useParams();
  const subscriptionId = id ? atob(id) : null;

  const initialState = {
    package_name: null,
    subscription_type: null,
    per_user_price: null,
    discount: 0,
    sell_price: null,
    duration: null,
    description: null,
    subscription_feature: [
      {
        feature_name: null,
        feature_status: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnloading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);

  useEffect(() => {
    const getSubscriptionDetail = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest("subscription/" + subscriptionId);
        if (apiResponse.data.success) {
          setState({
            ...apiResponse.data.data,
            package_name: apiResponse.data.data.package_name,
            subscription_type: apiResponse.data.data.subscription_type,
            per_user_price: apiResponse.data.data.per_user_price,
            discount: apiResponse.data.data.discount
              ? apiResponse.data.data.discount
              : 0,
            sell_price: apiResponse.data.data.sell_price,
            duration: apiResponse.data.data.duration,
          });
          formRef.current.setFieldsValue(apiResponse.data.data);
          setWeightSizeFieldValue(apiResponse.data.data.subscription_feature);
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    if (subscriptionId !== null) {
      getSubscriptionDetail();
    }
  }, [subscriptionId, t]);

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value ? value : null });
  };

  const handleSelectChange = (field, value) => {
    setState({ ...state, [field]: value });
  };

  const handleDiscountPrice = (field, value) => {
    let actualPrice =
      field === "per_user_price" ? Number(value) : state.per_user_price;
    let discount = field === "discount" ? Number(value) : state.discount;

    let discountValue = (discount / 100) * actualPrice;
    let sellPrice = actualPrice - discountValue;

    setState({
      ...state,
      per_user_price: actualPrice,
      discount: discount,
      sell_price: Math.round(sellPrice),
    });
    formRef.current.setFieldsValue({
      sell_price: sellPrice ? Math.round(sellPrice) : "",
    });
  };

  const addFeature = () => {
    let newFeatureArr = [
      ...state.subscription_feature,
      {
        feature_name: null,
        feature_status: null,
      },
    ];
    setState({ ...state, subscription_feature: newFeatureArr });
    setWeightSizeFieldValue(newFeatureArr);
  };

  const removePerson = async (lastIndex) => {
    let filterFeatureArr = state.subscription_feature.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, subscription_feature: filterFeatureArr });
    setWeightSizeFieldValue(filterFeatureArr);
  };

  const handleCloneInputChange = (field, e, index) => {
    let newFeatureArr = state.subscription_feature;
    newFeatureArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, subscription_feature: newFeatureArr });
  };

  const handleCloneSelectChange = (field, value, index) => {
    let newFeatureArr = state.subscription_feature;
    if (newFeatureArr[index]) {
      newFeatureArr[index][field] = value;
      setState({ ...state, subscription_feature: newFeatureArr });
    }
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["feature_name" + objectKey] = objectValue.feature_name;
      fieldObject["feature_status" + objectKey] = objectValue.feature_status;
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const handleSubmit = async () => {
    let apiResponse;

    const payload = {
      package_name: state.package_name,
      subscription_type: state.subscription_type,
      per_user_price: state.per_user_price,
      discount: state.discount,
      sell_price: state.sell_price,
      duration: state.duration,
      description: state.description,
      subscription_feature:
        state.subscription_feature &&
        state.subscription_feature.every(
          (feature) =>
            (feature.feature_name === null &&
              feature.feature_status === null) ||
            feature.feature_status === undefined
        )
          ? []
          : state.subscription_feature,
    };

    try {
      setBtnloading(true);
      if (subscriptionId === null) {
        apiResponse = await postRequest("subscription/", payload);
      } else {
        apiResponse = await patchRequest(
          `subscription/${subscriptionId}/`,
          payload
        );
      }
      if (apiResponse.data.success) {
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        SuccessNotificationMsg(
          subscriptionId === null
            ? t("msg_addSubscriptionSuccess")
            : t("msg_updateSubscriptionSuccess")
        );
        navigate("/subscription");
        setBtnloading(false);
      }
    } catch (err) {
      setBtnloading(false);
    }
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("Subscription")}</h3>
            {/* <div className="ListingTopBar"> */}
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/subscription">{t("subscriptionMaster")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {subscriptionId === null
                  ? t("addSubscription")
                  : t("editSubscription")}
              </Breadcrumb.Item>
            </Breadcrumb>
            {/* </div> */}
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <div className="stepscontentwrap" style={{ padding: 0 }}>
            <div className="stepsContent">
              <Spin spinning={apiLoading}>
                <Form
                  // onFinish={handleSubmit}
                  autoComplete="off"
                  ref={formRef}
                  initialValues={{ discount: state.discount }}
                >
                  <Row gutter={[15]}>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <InputField
                        prefix={<CoinIcon />}
                        label={t("label_package_name")}
                        placeholder={t("label_package_name")}
                        name="package_name"
                        rules={t("val_package_name")}
                        handleInputChange={handleInputChange}
                      />
                    </Col>

                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name="subscription_type"
                        label={t("pl_subscription_type")}
                        rules={[
                          {
                            required: true,
                            message: (
                              <Trans>{t("val_subscription_type")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Select
                          showArrow
                          placeholder={t("pl_subscription_type")}
                          onChange={(value) =>
                            handleSelectChange("subscription_type", value)
                          }
                        >
                          <Select.Option value="Enterprise">
                            Enterprise
                          </Select.Option>
                          <Select.Option value="peruser">Peruser</Select.Option>
                          <Select.Option value="on_premise">
                            On-Premise
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        label={t("pl_per_user_price")}
                        name="per_user_price"
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_per_user_price")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          prefix={<RupeesSign />}
                          type="number"
                          placeholder={t("pl_per_user_price")}
                          onChange={(value) =>
                            handleDiscountPrice(
                              "per_user_price",
                              value.target.value
                            )
                          }
                          value={state.per_user_price}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        label={t("pl_discount")}
                        name="discount"
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_discount")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          addonBefore="%"
                          //prefix={<RupeesSign />}
                          type="number"
                          placeholder={t("pl_discount")}
                          onChange={(value) =>
                            handleDiscountPrice("discount", value.target.value)
                          }
                          value={state.discount}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item label={t("pl_sell_price")} name="sell_price">
                        <Input
                          prefix={<RupeesSign />}
                          placeholder={t("pl_enter_sell_price")}
                          value={state.sell_price}
                          readOnly
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        label={t("pl_duration")}
                        name="duration"
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_duration")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          prefix={<ClockIcon />}
                          type="number"
                          placeholder={t("pl_enter_duration")}
                          onChange={(value) =>
                            setState({ ...state, duration: value.target.value })
                          }
                          value={state.duration}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={6}
                      xl={6}
                      className="TextFeild gutter-row"
                    >
                      <InputField
                        label={t("pl_description_subscription")}
                        prefix={<About />}
                        placeholder={t("pl_description")}
                        name="description"
                        rules={t("val_description")}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                  </Row>

                  {authUserData()?.permission.includes(
                    "subcription|view_subscriptionfeature"
                  ) && (
                    <>
                      <h3
                        style={{
                          backgroundColor: "#F8F8F8",
                          padding: "5px 16px",
                          borderRadius: "10px",
                          margin: "10px 0",
                          fontSize: "16px",
                        }}
                      >
                        Feature
                      </h3>

                      {/* <Divider /> */}
                      {/* {state.subscription_feature.map((x, index) => { */}
                      {state.subscription_feature &&
                        state.subscription_feature.map((x, index) => {
                          // {state.subscription_feature && state.subscription_feature.map((x, index) => {
                          return (
                            <Row
                              className="AddColumnSec"
                              key={index}
                              gutter={[15]}
                            >
                              <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                              >
                                <Form.Item
                                  name={`feature_name` + index}
                                  rules={[
                                    {
                                      min: 3,
                                      message: (
                                        <Trans>{t("minlength_msg")}</Trans>
                                      ),
                                    },
                                    {
                                      max: 30,
                                      message: (
                                        <Trans>
                                          {t("maxlength_personName")}
                                        </Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={t("pl_purchase_requistions")}
                                    onChange={(value) =>
                                      handleCloneInputChange(
                                        "feature_name",
                                        value,
                                        index
                                      )
                                    }
                                  />
                                </Form.Item>
                              </Col>

                              <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={6}
                                xl={6}
                                className="TextFeild gutter-row"
                              >
                                <Form.Item name={`feature_status` + index}>
                                  <Select
                                    showArrow
                                    allowClear
                                    placeholder="Feature Status"
                                    onChange={(value) =>
                                      handleCloneSelectChange(
                                        "feature_status",
                                        value,
                                        index
                                      )
                                    }
                                  >
                                    <Select.Option value={true}>
                                      True
                                    </Select.Option>
                                    <Select.Option value={false}>
                                      False
                                    </Select.Option>
                                  </Select>
                                </Form.Item>
                              </Col>

                              <Col xs={24} sm={12} md={4}>
                                <div className="addwrp">
                                  <Space>
                                    {index !== 0 ? (
                                      <MinusSquareFilled
                                        className="add"
                                        onClick={() => removePerson(index)}
                                      />
                                    ) : (
                                      ""
                                    )}

                                    <PlusSquareFilled
                                      className="add"
                                      onClick={(e) => addFeature(e)}
                                    />
                                  </Space>
                                </div>
                              </Col>
                            </Row>
                          );
                        })}
                    </>
                  )}
                </Form>
              </Spin>
            </div>
            <div className="FormFooter">
              <ButtonField
                type="primary"
                className="CancelGradiantBtn"
                htmlType="button"
                label={t("cancel")}
                onClick={() => navigate("/subscription")}
              />

              <ButtonField
                type="primary"
                className="SaveGradiantBtn"
                label={t("save")}
                htmlType="submit"
                onClick={handleSubmit}
                loading={btnLoading}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddSubscription;
